<template>
    
    <div class="container">
        <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">دستیار هوش مصنوعی ناباکو</h2>
            <div class="row mt-5">
                <h5 class="mt-3">
                    دستیار هوش مصنوعی ترید ناباکو، طراحی شده است تا به شما کمک کند در دنیای پیچیده و سریع معاملات مالی تصمیمات آگاهانه‌تر و موفق‌تری بگیرید. با استفاده از قدرت تجزیه و تحلیل داده‌های لحظه‌ای و پیش‌بینی‌های دقیق، این دستیار شما را برای افزایش بازدهی و کاهش ریسک معاملات مجهز می‌کند.
                    <br>
                    <br>
                    <br>
                    برای استفاده از خدمات اینجا راکلیک کنید
                    <br>
                    <br>
                    <button class="btn-gold my-2">
                      <a href="https://survey.porsline.ir/s/sP04J912" style="color: black; text-decoration: none;">لینک آزمون</a>
                    </button>
                    <br>
                    <br>
                    <br>
                    با دستیار هوش مصنوعی ترید ناباکو، معاملات خود را هوشمندتر از همیشه انجام دهید. همین حالا <a href="../sign-up">ثبت نام</a> و از قدرت AI بهره‌مند شوید!
                </h5>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>